export default "__VITE_PUBLIC_ASSET__8d019997__"